import React, {Fragment} from 'react';
import {
  TextField,
  Typography
} from '@material-ui/core';

import StringListEdit from '../common/StringListEdit';
import {YeastFirestoreService} from '../../firebase';
import {FormErrors, InputEvent, SelectEvent} from '../../helpers/useFormValidation';
import {Yeast} from '../../models';
import ItemEdit, {useItemEditStyles} from '../common/ItemEdit';
import LinkListEdit from '../common/LinkListEdit';


function validateYeast(values: Yeast) {
  let errors: FormErrors<Yeast> = {};

  // Name Errors
  if (!values.name) {
    errors.name = "Name required";
  } else if (values.name.length < 2) {
    errors.name = "Name must be at least 2 characters";
  }

  // Picklist Name Errors
  if (!values.picklistName) {
    errors.picklistName = "Picklist Name required";
  } else if (values.picklistName.length < 2) {
    errors.picklistName = "Picklist Name must be at least 2 characters";
  }

  return errors;
}

const INITIAL_VALUE = new Yeast();

interface Props {
  yeast?: Yeast | null
  id?: string | null;
  onComplete?: () => void
}

const YeastEdit = (props: Props) => {

  const {id, yeast, onComplete} = props;
  console.log("YeastEdit", yeast);

  const classes = useItemEditStyles();

  const renderFields = (
    formItem: Yeast|null,
    formErrors: FormErrors<Yeast>,
    handleBlur: ()=> void,
    handleChange: (event: InputEvent|SelectEvent) => void,
    updateProperty: (name: string, value: any) => void,
  ) => {
    return (
      <Fragment>
        <Typography
          className={classes.title}
          variant="h2"
        >
          {formItem?.name || "New Yeast"}
        </Typography>
        <TextField
          autoComplete="off"
          className={classes.textField}
          error={formErrors.name != null}
          fullWidth
          helperText={formErrors.name}
          label="Name"
          name="name"
          onChange={handleChange}
          onBlur={handleBlur}
          type="text"
          value={formItem?.name || ''}
          variant="outlined"
        />
        <TextField
          autoComplete="off"
          className={classes.textField}
          error={formErrors.picklistName != null}
          fullWidth
          helperText={formErrors.picklistName}
          label="Picklist Name"
          name="picklistName"
          onChange={handleChange}
          onBlur={handleBlur}
          type="text"
          value={formItem?.picklistName || ''}
          variant="outlined"
        />
        <StringListEdit
          label="Alias"
          value={formItem?.aliases}
          onChange={(val) => updateProperty('aliases', val)}
        />
        <TextField
          autoComplete="off"
          className={classes.textField}
          error={formErrors.description != null}
          fullWidth
          helperText={formErrors.description}
          label="Description"
          multiline
          name="description"
          onChange={handleChange}
          onBlur={handleBlur}
          type="text"
          value={formItem?.description || ''}
          variant="outlined"
        />
        <TextField
          autoComplete="off"
          className={classes.textField}
          error={formErrors.creator != null}
          fullWidth
          helperText={formErrors.creator}
          label="Created By"
          name="creator"
          onChange={handleChange}
          onBlur={handleBlur}
          type="text"
          value={formItem?.creator || ''}
          variant="outlined"
        />
        <LinkListEdit
          value={formItem?.links}
          onChange={(val) => updateProperty("links", val)}
        />
      </Fragment>
    );
  };

  return (
    <ItemEdit
      item={yeast}
      defaultValue={INITIAL_VALUE}
      id={id}
      service={YeastFirestoreService}
      fieldRenderer={renderFields}
      validator={validateYeast}
      onComplete={onComplete}
    />
  );
};

export default YeastEdit;
